import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Footer from './components/Footer';
import TermPolicy from './components/TermPolicy';
import Blog from './pages/Blog';
import NotFound from './pages/NotFound';

const SITE_URL = 'https://demosw.ganotras.in';

function AppRouter() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [page, setPage] = useState('home');
  const [policyRoute, setPolicyRoute] = useState(''); // '', 'terms', 'privacy', 'policy'

  useEffect(() => {
    const path = window.location.pathname.replace(/^\//, '').replace(/\/$/, '');
    const knownPages = ['home', 'blog', 'login', 'admin', 'policy'];

    if (!path || path === 'home') {
      setPage('home');
      setPolicyRoute('');
      if (window.location.pathname !== '/') {
        window.history.replaceState({}, '', '/');
      }
      return;
    }

    if (knownPages.includes(path)) {
      setPage(path);
      setPolicyRoute('');
      return;
    }

    if (path === 'terms' || path === 'privacy') {
      setPage('policy');
      setPolicyRoute(path);
      return;
    }

    setPage('not-found');
    setPolicyRoute('');
  }, []);

  useEffect(() => {
    const updateSeo = (route, activePolicy = '') => {
      const baseTitle = 'NeeBun | Professional Web & Mobile App Development';
      const description = 'NeeBun builds modern web and mobile applications for businesses in India with fast, secure, and scalable digital solutions.';
      const canonicalPath = route === 'home' ? '/' : route === 'policy' ? `/${activePolicy || 'terms'}` : `/${route}`;
      const canonicalUrl = `${SITE_URL}${canonicalPath}`;
      const robots = route === 'home' || route === 'blog' || route === 'policy' ? 'index,follow' : 'noindex,follow';

      document.title = route === 'home' ? baseTitle : route === 'not-found' ? '404 - Page Not Found' : `${route.charAt(0).toUpperCase() + route.slice(1)} | NeeBun`;

      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);

      let metaRobots = document.querySelector('meta[name="robots"]');
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute('content', robots);

      let canonicalTag = document.querySelector('link[rel="canonical"]');
      if (!canonicalTag) {
        canonicalTag = document.createElement('link');
        canonicalTag.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalTag);
      }
      canonicalTag.setAttribute('href', canonicalUrl);

      let ogUrlTag = document.querySelector('meta[property="og:url"]');
      if (!ogUrlTag) {
        ogUrlTag = document.createElement('meta');
        ogUrlTag.setAttribute('property', 'og:url');
        document.head.appendChild(ogUrlTag);
      }
      ogUrlTag.setAttribute('content', canonicalUrl);
    };

    const route = page === 'policy' ? 'policy' : page === 'not-found' ? 'not-found' : page;
    updateSeo(route, policyRoute);
  }, [page, policyRoute]);

  const handleNavigate = (to) => {
    setPolicyRoute('');
    setPage(to);
    window.history.pushState({}, '', to === 'home' ? '/' : `/${to}`);
  };

  // Footer policy navigation
  const handlePolicyNav = (route) => {
    setPolicyRoute(route);
    setPage('policy');
    window.history.pushState({}, '', `/${route}`);
  };

  const handleLogin = () => {
    setIsLoggedIn(true);
    setPage('admin');
    window.history.pushState({}, '', '/admin');
  };

  const handleLogout = async () => {
    await fetch('/server/logout.php');
    setIsLoggedIn(false);
    setPage('home');
    window.history.pushState({}, '', '/');
  };

  let content;
  if (page === 'policy') {
    content = <TermPolicy section={policyRoute} />;
  } else if (!isLoggedIn && page === 'login') {
    content = <Login onLogin={handleLogin} />;
  } else if (page === 'blog') {
    content = <Blog />;
  } else if (isLoggedIn && page === 'admin') {
    content = <Admin />;
  } else if (page === 'not-found') {
    content = <NotFound />;
  } else {
    content = <Home />;
  }

  return (
    <div className="main-app">
      <Navbar
        isLoggedIn={isLoggedIn}
        onNavigate={handleNavigate}
        onLogout={handleLogout}
        currentPage={page}
      />
      <main className="main-content">{content}</main>
      <Footer onPolicyNav={handlePolicyNav} />
    </div>
  );
}

export default AppRouter;
